import React from 'react';

import {backgroundForgotPassword} from '../../assets/images';
import {Button} from '../../components/Button';
import {Text} from '../../components/Typography';
import {Messages, Strings, texts} from '../../constants/Strings';
import {Screens} from '../../constants/navigation';
import {useBackPress} from '../../lib/hooks/useBackPress';
import {useBreakpoints} from '../../lib/hooks/useBreakpoints';
import {openApp} from '../../lib/hooks/useOpenApp';
import type {RootStackScreenProps} from '../../navigators/RootStackNavigator';
import {centerText} from '../../styles';
import {TermsAndPrivacy} from '../components';
import {
  BodyContainer,
  ContentContainer,
  FlexImage,
  Footer,
  ImageContainer,
  Layout,
  TitleContainer,
} from '../components/composable';

export interface Props {
  email: string;
}

interface ScreenProps
  extends RootStackScreenProps<typeof Screens.PasswordConfirmed> {}

export const PasswordConfirmedScreen: React.FC<ScreenProps> = ({
  navigation,
  route,
}) => {
  const {isMedium} = useBreakpoints();

  useBackPress(() => {
    navigation.goBack();
    return true;
  });

  const onPress = () =>
    openApp(`/login?email=${route.params?.email ?? ''}&canSkip=true`);

  return (
    <Layout>
      <ImageContainer>
        <FlexImage source={backgroundForgotPassword} />
      </ImageContainer>

      <ContentContainer>
        <BodyContainer>
          <TitleContainer>
            <Text style={centerText} variant="h2">
              {texts.screens.passwordConfirmed.title}
            </Text>
          </TitleContainer>

          <Text style={centerText}>{texts.screens.passwordConfirmed.body}</Text>
        </BodyContainer>

        <Footer>
          <Button {...{onPress}}>{Strings.DEFAULT_BTN}</Button>

          <Text variant={isMedium ? 'xs' : 's'} style={centerText}>
            {Messages.LEGAL_AGREEMENT} <TermsAndPrivacy />
          </Text>
        </Footer>
      </ContentContainer>
    </Layout>
  );
};
